<template>
  <div class="container">
    <main id="main" class="container">
      <!-- <div class="filtering">
        <ul class="filter-group">
          <li><a class="is-checked" href="work.html">工程体系</a></li>
          <li><a href="service.html">服务申请</a></li>
          <li><a href="faq.html">常见问题</a></li>
        </ul>
      </div> -->
      <div
        class="our-blog our-blog-1 section-padding-top sections product-items-container row"
      >
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="guardianship">
                <h2>家长监护工程体系介绍</h2>
                <h4>前言</h4>
                <P
                  >“网络游戏未成年人家长监护工程”是一项由本公司根据国家有关规定而发起的一个项目，由中华人民共和国文化部指导，旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。</P
                ><P>
                  它提供了一种切实可行的方法，一种家长实施监控的管道，使家长纠正部分未成年子女沉迷游戏的行为成为可能。</P
                ><P>
                  该项社会公益行动充分反映了中国网络游戏行业高度的社会责任感，对未成年玩家合法权益的关注及对用实际行动营造和谐社会的愿望。</P
                >
                <h4>
                  《未成年人健康参与网络游戏提示》
                </h4>
                <P>
                  随着网络在青少年中的普及，未成年人接触网络游戏已经成为普遍现象。为保护未成年人健康参与游戏，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人参与网络游戏提供以下意见：</P
                ><P>
                  一、主动控制游戏时间。游戏只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络游戏中的行为和体验。</P
                ><P>
                  二、不参与可能耗费较多时间的游戏设置。不玩大型角色扮演类游戏，不玩有PK类设置的游戏。在校学生每周玩游戏不超过2小时，每月在游戏中的花费不超过10元。</P
                ><P>
                  三、不要将游戏当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠游戏来缓解压力。</P
                ><P>
                  四、养成积极健康的游戏心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。</P
                ><P>
                  五、注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。</P
                >
                <h4>
                  家长监护服务说明：
                </h4>
                <P
                  >家长监护系统充分考虑家长的实际需求，当家长发现自己的孩子玩游戏过于沉迷的时候，由家长提供合法的监护人资质证明、游戏名称账号、以及家长对于限制强度的愿望等信息，可对处于孩子游戏沉迷状态的账号采取几种限制措施，解决未成年人沉迷游戏的不良现象，如限制未成年人每天玩游戏的时间区间和长度，也可以限制只有节假日才可以游戏，或者完全禁止。</P
                >
                <h4>家长监护服务进度查询：</h4>
                <P>
                  如果您已经申请家长监护服务，在服务期间，当您对需要提交的信息、处理结果有疑问，或者其他任何问题，您均可以在工作时间联系我们，我们将由专门负责的受理专员为您提供咨询解答服务，或者配合、指导您解决问题。</P
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    //这里存放数据
    return {};
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {},
};
</script>
<style lang="less" scoped>
@import url("../../index.less");
</style>
